import packagesSearch from '../../../utils/packages-search'
import {
  PACKAGE_SEARCH_DATA,
  persistSearchData
} from '../../../utils/local-forage-helper'
import analytics from '../../../utils/analytics'
import { STAY_DRIVE, STAY_FLY_DRIVE, FLY_DRIVE, STAY_FLY } from './TripTypes'

export const onSubmit = values => {
  const ANALYTICS_CATEGORY = values.gaCategory
  const { startLocation, endLocation, childrenAges, ...rest } = values
  const isPartialStayDateValid =
    !!rest.partialStay &&
    (rest.hotelStartDate !== rest.startDate ||
      rest.hotelEndDate !== rest.endDate)

  packagesSearch({
    startLocationObject: startLocation,
    endLocationObject: endLocation,
    childrenAges,
    ...rest,
    isPartialStayDateValid:
      isPartialStayDateValid && rest.tripType !== STAY_DRIVE
  })

  persistSearchData(PACKAGE_SEARCH_DATA, values)
  if (isPartialStayDateValid) {
    analytics.fireEvent({
      category: ANALYTICS_CATEGORY,
      action: 'VP Search Button',
      label: 'Partial search'
    })
  }

  if (rest.isRecommendedTrip) {
    analytics.fireEvent({
      category: ANALYTICS_CATEGORY,
      action: 'VP Search Button',
      label: 'Recommended Trip search'
    })
  }

  if (!isPartialStayDateValid && !rest.isRecommendedTrip) {
    analytics.fireEvent({
      category: ANALYTICS_CATEGORY,
      action: 'VP Search Button',
      label: 'Normal search'
    })
  }

  if (rest.pickupCarSomewhere) {
    analytics.fireEvent({
      action: 'H+C - Different Location Search',
      category: ANALYTICS_CATEGORY
    })
  }

  if (!rest.pickupCarIncludeAirport) {
    analytics.fireEvent({
      action: 'Hide On Airport Inventory',
      category: ANALYTICS_CATEGORY
    })
  }
}

export const getTextString = tripType => text => {
  switch (tripType) {
    case STAY_FLY_DRIVE:
      return `${text}hotel, flight and car`
    case FLY_DRIVE:
      return `${text}flight and car`
    case STAY_DRIVE:
      return `${text}hotel and car`
    case STAY_FLY:
    default:
      return `${text}hotel and flight`
  }
}

export const CALENDAR_POPOVER_SELECTOR =
  '[aria-label="Calendar navigation tooltip"]'

export const initialState = {
  tripType: STAY_FLY,
  partialStay: false,
  startLocation: null,
  endLocation: null,
  startDate: '',
  endDate: '',
  hotelStartDate: '',
  hotelEndDate: '',
  roomCount: 1,
  adultCount: 2,
  childrenCount: 0,
  childrenAges: [],
  isRecommendedTrip: false,
  includeBasicEconomy: true,
  pickupCarSomewhere: false,
  pickupCarIncludeAirport: true,
  rcLocation: null,
  rcPickupDate: '',
  rcDropoffDate: '',
  rcPickupTime: '10:00',
  rcDropoffTime: '10:00'
}

export const fields = [
  'startLocation',
  'endLocation',
  'startDate',
  'endDate',
  'hotelStartDate',
  'hotelEndDate',
  'roomCount',
  'adultCount',
  'childrenCount',
  'childrenAges',
  'tripType',
  'includeBasicEconomy',
  'pickupCarSomewhere',
  'pickupCarIncludeAirport',
  'rcLocation',
  'rcPickupDate',
  'rcDropoffDate',
  'rcPickupTime',
  'rcDropoffTime',
  'gaCategory'
]
